import { render, staticRenderFns } from "./CotizacionGeneral.vue?vue&type=template&id=412be049&"
import script from "./CotizacionGeneral.vue?vue&type=script&lang=js&"
export * from "./CotizacionGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports